import { defineStore } from 'pinia';
import * as api from '@/api';
import { PERMISSIONS } from '@/constants/auth';
import router, { constantRoutes } from '@/router';
import pinia from '@/stores/store';
import { useMenuStore } from './menu';
import { tagViewStore } from './tagsView';

const tagViewStores = tagViewStore(pinia);

export const userStore = defineStore('userStore', {
  state: () => ({
    collapse: false,
    token: '',
    userName: '',
    userId: '',
    authMap: {},
  }),
  persist: true,
  actions: {
    toggleCollapse(collapse) {
      this.collapse = !collapse;
    },
    setToken(token) {
      this.token = token;
    },
    async login({ token, userId, userName }) {
      localStorage.setItem('token', token);
      this.setToken(token);
      this.userId = userId;
      this.userName = userName;
      const menuStore = useMenuStore(pinia);
      const noAuth = await menuStore.getSidebarList();
      if (noAuth) {
        this.authMap.clear();
        this.loginOut();
        return;
      }
      await this.checkPermissions();
      await tagViewStores.clearHomeView();
      await tagViewStores.deleteAllViews();
      router.push({ path: '/' });
      console.log(router.getRoutes());
    },
    async refreshAuth(compId = '') {
      const menuStore = useMenuStore(pinia);
      const noAuth = await menuStore.getSidebarList(compId);
      if (noAuth) {
        this.loginOut();
        return;
      }
      await this.checkPermissions();
      await tagViewStores.clearHomeView();
      await tagViewStores.deleteAllViews();
      router.push({ path: '/' });
    },
    async reset() {
      // 获取当前所有路由
      const allRoutes = router.getRoutes();
      // 移除所有路由，只保留constantRoutes中的路由
      allRoutes.forEach(route => {
        // 检查当前路由是否在constantRoutes中
        const isConstantRoute = constantRoutes.some(constantRoute => constantRoute.path === route.path);
        if (!isConstantRoute && route.name) {
          console.log('移除路由:', route.path, route.name);
          router.removeRoute(route.name);
        }
      });
      // 2. 重置菜单store状态
      const menuStore = useMenuStore(pinia);
      menuStore.routes = [];
      menuStore.authRoutes = [];
      menuStore.activePath = '';
      menuStore.menus = [];

      console.log('routes', router.getRoutes());

      // 3. 重置用户状态
      router.push('/login');
      this.setToken(null);
      localStorage.removeItem('routes');
      localStorage.removeItem('token');
      await tagViewStores.clearHomeView();
      tagViewStores.deleteAllViews();
    },
    async loginOut() {
      await api.userManageApi.loginOut();
      this.reset();
    },
    /** 获取用户是否有访问特定接口的权限 */
    async checkPermissions() {
      const data = await api.menuSourceApi.checkUserResources({
        productCode: 'emcomp-back-office',
        resourceList: [...PERMISSIONS()],
      });
      if (!data || !Array.isArray(data) || data.length === 0) {
        return false;
      }
      //将权限数据存入 authMap
      data.forEach(item => {
        this.authMap[item.resource] = item.flag;
      });
    },
    hasPermission(resource: string): boolean {
      return this.authMap[resource] ?? false;
    },
  },
});
